export type FeedbackVariant = 'star' | 'dislike' | 'like';

export interface FeedbackOption {
  id: string;
  label: string;
}

export const FEEDBACK_OPTIONS: Record<FeedbackVariant, FeedbackOption[]> = {
  star: [
    { id: 'perfect-voice', label: 'Perfect voice' },
    { id: 'best-answer', label: 'Best answer' },
    { id: 'very-helpful', label: 'Very helpful' },
    { id: 'great-memory', label: 'Great memory' },
    { id: 'engaging', label: 'Engaging' },
    { id: 'feels-authentic', label: 'Feels authentic' },
  ],
  dislike: [
    { id: 'not-accurate', label: 'Not accurate (wrong / made up)' },
    { id: 'doesnt-sound', label: "Doesn't sound like them" },
    { id: 'ignored', label: 'Ignored what I said' },
    { id: 'not-helpful', label: 'Not helpful (too vague)' },
    { id: 'too-long', label: 'Answer too long' },
    { id: 'too-short', label: 'Answer too short' },
  ],
  like: [
    { id: 'interesting', label: 'Interesting' },
    { id: 'engaging-like', label: 'Engaging' },
    { id: 'funny', label: 'Funny' },
    { id: 'helpful', label: 'Helpful' },
    { id: 'good-memory', label: 'Good Memory of context' },
    { id: 'sounds-exactly', label: 'Sounds exactly like them' },
  ],
};
